// extracted by mini-css-extract-plugin
export default {"notification":"notifications_notification__L73BD"};